/* eslint-disable @typescript-eslint/no-explicit-any */

import type { CreateRoleFormValues, UpdateRoleFormValues } from '@/schemas/role.schema';

import type { Permission, Role } from '@/types/role.type';

export const mapRoleResponse = (payload: Record<string, any>): Role => {
  const data = payload.data;

  return {
    id: data.id,
    name: data.name,
    description: data.description,
    permissions: mapPermissionReponse({ data: data.permissions }),
  };
};

export const mapRoleListResponse = (data: Record<string, any>): Role[] => {
  return data.data.map((item: Record<string, any>) => mapRoleResponse({ data: item }));
};

export const mapPermissionReponse = (data: Record<string, any>): Permission[] => {
  return data.data.map((item: Record<string, any>) => ({
    id: item.id,
    name: item.name,
    label: item.label,
  }));
};

export const mapRoleCreatePayload = (data: CreateRoleFormValues): Record<string, any> => {
  const formattedData = {
    name: data.name,
    description: data.description,
    permission_ids: data.permissions.map(p => Number(p.value)),
  };

  return formattedData;
};

export const mapRoleUpdatePayload = (data: UpdateRoleFormValues): Record<string, any> => {
  return {
    name: data.name,
    description: data.description,
    add_permission_ids: data.add_permission_ids || [],
    remove_permission_ids: data.remove_permission_ids || [],
  };
};
